import cheerio from 'cheerio';
import { IStoryContent } from '../types';

export const disableClickForV3Embed = (content: string) => {
  const $ = cheerio.load(content, {
    xmlMode: false,
    decodeEntities: false
  });

  $('script').each((index, elem) => {
    // Check if the script tag has data-embed-version="v3"
    if ($(elem).attr('data-embed-version') === 'v3') {
      // Get the script content
      const scriptContent = $(elem).html();
      // Check if the script content contains disableClick: false
      if (scriptContent.includes('disableClick: false')) {
        // Replace disableClick: false with disableClick: true
        const updatedScriptContent = scriptContent.replace('disableClick: false', 'disableClick: true');
        // Update the script tag with the modified content
        $(elem).html(updatedScriptContent);
      }
    }
  });

  $('iframe').each((index, elem) => {
    const src = $(elem).attr('src');
    // Check if the src contains /v3/embeds/ and disableClick=false
    if (src && src.includes('/v3/embeds/') && src.includes('disableClick=false')) {
      // Replace disableClick=false with disableClick=true in the src attribute
      const updatedSrc = src.replace('disableClick=false', 'disableClick=true');
      // Update the iframe tag with the modified src
      $(elem).attr('src', updatedSrc);
    }
  });

  return $('body').html();
};

export const disableClickFromStoryContentWithEmbedV3 = (storyContents: IStoryContent[]) => {
  return storyContents.map((storyContent) => {
    storyContent.content = disableClickForV3Embed(storyContent.content);
    if (storyContent.contentHtml) {
      storyContent.contentHtml = disableClickForV3Embed(storyContent.contentHtml);
    }
    return storyContent;
  });
};
